module.exports = "/fonts/HelveticaNeueItalic.woff?f949131959c8c7a248da48d7efa5d4b8";